import type { OrderDetailModel } from './orderDetail.model';

export const ORDER_DETAIL_MODEL_INIT: OrderDetailModel = {
  id: NaN,
  bundleId: '',
  status: 'new_order',
  statusAuxiliary: 'in_store',
  isEnabledOM: false,
  isAuditable: false,
  specialOrderTypes: [],
  deliveryMethod: 'delivery',
  products: [],
  substitutionFlowState: null,
  user: {
    id: NaN,
    name: {
      first: '',
      last: '',
      full: '',
      basic: '',
    },
    tag: {
      isNew: false,
      isPro: false,
    },
    chat: {
      isUserAppEnabled: false,
    },
    phone: {
      hasProxySession: false,
      number: '',
    },
    address: {
      street: '',
      description: '',
      location: {
        zipCode: '',
        neighborhood: '',
        coordinates: {
          lat: NaN,
          lng: NaN,
        },
      },
      full: '',
    },
    billing: {
      hasDocument: false,
      type: '',
      email: '',
      address: '',
      phone: '',
      document: {
        owner: {
          label: '',
          value: '',
        },
        description: {
          label: '',
          value: '',
        },
      },
    },
  },
  totals: {
    main: {
      id: 'total',
      label: 'Valor total',
      price: 0.0,
      isZero: true,
      isNegative: false,
    },
    detail: {
      length: 0,
      item: {},
      extraItems: [],
    },
    error: null,
  },
};
